import { Select, SelectField, type SelectFieldProps, type SelectProps } from '@nvision/ui';

import { useLinerTypes } from '../../hooks';
import type { LinerType, LinerTypeFilters } from '../../models';

export interface LinerTypeFieldProps extends Omit<SelectProps<LinerType>, 'options'> {
  defaultFilters?: Partial<LinerTypeFilters & { searchParams: { ids: string[] } }>;
  label?: string;
  errorMessage?: SelectFieldProps<LinerType>['errorMessage'];
  isInvalid?: boolean;
}

export const LinerTypeField: React.FC<LinerTypeFieldProps> = ({ defaultFilters, label, ...otherFieldProps }) => {
  const { data, isLoading, updateFilters } = useLinerTypes(defaultFilters);

  if (label) {
    return (
      <SelectField
        {...otherFieldProps}
        label={label}
        placeholder="Select"
        options={data?.list ?? []}
        onInputChange={(search) => updateFilters({ search: { codeDesc: search } })}
        isLoading={isLoading}
      />
    );
  }

  return (
    <Select
      {...otherFieldProps}
      placeholder="Select"
      options={data?.list ?? []}
      onInputChange={(search) => updateFilters({ search: { codeDesc: search } })}
      isLoading={isLoading}
    />
  );
};
